/**
 * 新版购物车页面交互 JS
 * 处理数量更新、删除商品等功能
 */

(function() {
  'use strict';

  // 配置
  const CONFIG = {
    selectors: {
      cartContainer: '#new-cart-items',
      cartRow: '.static-cart__row',
      quantityInput: '.static-cart__quantity-input',
      quantityBtn: '.static-cart__quantity-btn',
      removeBtn: '.static-cart__remove',
      subtotalTitle: '.checkout-subtotal-title',
      // Order Summary 价格选择器
      cartTotal: '.ecom-cart__informations-total_price .ecom-cart__information-text',
      cartOriginalTotal: '.ecom-cart__informations-original_total_price .ecom-cart__information-text',
      cartDiscount: '.ecom-cart__informations-discount_application .ecom-cart__informations-discount_application-value',
      checkoutBtn: '.ecom-cart__checkout-button--submit'
    },
    routes: {
      cart: '/cart.js',
      cartChange: '/cart/change.js',
      cartUpdate: '/cart/update.js'
    },
    debounceDelay: 300
  };

  // 防抖函数
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // 更新顶部导航购物车数量
  function updateHeaderCartCount(count) {
    // 更新各种购物车数量显示元素
    const countElements = document.querySelectorAll(
      '.cart-link__bubble-num, .cart-count, [data-cart-count], .js-cart-count'
    );
    countElements.forEach(el => {
      el.textContent = count;
    });

    // 处理购物车气泡显示/隐藏
    const bubbles = document.querySelectorAll('.cart-link__bubble');
    bubbles.forEach(bubble => {
      // 部分外部 App 会直接给 bubble 设置 textContent，导致内部数量节点被删除。
      // 每次更新时补回标准结构，确保后续加购仍有稳定的更新目标。
      let bubbleNum = bubble.querySelector('.cart-link__bubble-num');
      if (!bubbleNum) {
        bubble.textContent = '';
        bubbleNum = document.createElement('span');
        bubbleNum.className = 'cart-link__bubble-num';
        bubble.appendChild(bubbleNum);
      }
      bubbleNum.textContent = count;

      if (count > 0) {
        bubble.classList.add('cart-link__bubble--visible');
      } else {
        bubble.classList.remove('cart-link__bubble--visible');
      }
    });
  }

  // 显示库存不足警告
  function showStockWarning(row, message) {
    if (!row) return;
    
    const quantityWrapper = row.querySelector('.static-cart__quantity-wrapper');
    if (!quantityWrapper) return;
    
    let warningEl = quantityWrapper.querySelector('.static-cart__stock-warning');
    if (!warningEl) {
      warningEl = document.createElement('span');
      warningEl.className = 'static-cart__stock-warning';
      quantityWrapper.appendChild(warningEl);
    }
    
    warningEl.textContent = message;
    warningEl.classList.add('is-visible');
    
    // 3秒后隐藏警告
    setTimeout(() => {
      warningEl.classList.remove('is-visible');
    }, 3000);
  }

  // 显示 Bundle 商品库存/错误警告
  function showBundleStockWarning(bundleGroupEl, message) {
    if (!bundleGroupEl) return;
    
    const quantityWrapper = bundleGroupEl.querySelector('.static-cart__quantity-wrapper');
    if (!quantityWrapper) return;
    
    let warningEl = quantityWrapper.querySelector('.static-cart__stock-warning');
    if (!warningEl) {
      warningEl = document.createElement('span');
      warningEl.className = 'static-cart__stock-warning';
      quantityWrapper.appendChild(warningEl);
    }
    
    // 简化错误信息：如果是 "sold out" 类型的错误，简化显示
    let displayMessage = message;
    if (message && message.toLowerCase().includes('sold out')) {
      displayMessage = 'Insufficient stock';
    } else if (message && message.length > 30) {
      // 如果消息太长，截取显示
      displayMessage = 'Insufficient stock';
    }
    
    warningEl.textContent = displayMessage;
    warningEl.classList.add('is-visible');
    
    // 禁用增加按钮
    const increaseBtn = bundleGroupEl.querySelector('[data-action="increase-bundle"]');
    if (increaseBtn) {
      increaseBtn.classList.add('is-disabled');
      increaseBtn.disabled = true;
    }
    
    // 不自动隐藏，一直显示
  }
  
  // 隐藏 Bundle 商品警告并启用按钮（减少数量成功后调用）
  function hideBundleStockWarning(bundleGroupEl) {
    if (!bundleGroupEl) return;
    
    const quantityWrapper = bundleGroupEl.querySelector('.static-cart__quantity-wrapper');
    if (!quantityWrapper) return;
    
    const warningEl = quantityWrapper.querySelector('.static-cart__stock-warning');
    if (warningEl) {
      warningEl.classList.remove('is-visible');
    }
    
    // 启用增加按钮
    const increaseBtn = bundleGroupEl.querySelector('[data-action="increase-bundle"]');
    if (increaseBtn) {
      increaseBtn.classList.remove('is-disabled');
      increaseBtn.disabled = false;
    }
  }

  // 显示持久提示（不自动消失），用于拆分商品后找不到迁移映射的场景
  function showMigrationAnomalyBadge(row, message) {
    if (!row) return;

    const quantityWrapper = row.querySelector('.static-cart__quantity-wrapper');
    if (!quantityWrapper) return;

    let warningEl = quantityWrapper.querySelector('.static-cart__migration-badge');
    if (!warningEl) {
      warningEl = document.createElement('span');
      warningEl.className = 'static-cart__stock-warning static-cart__migration-badge';
      quantityWrapper.appendChild(warningEl);
    }

    warningEl.textContent = message;
    warningEl.classList.add('is-visible');
  }

  // 格式化金额
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const defaultFormat = '${{amount}}';
    format = format || window.theme?.moneyFormat || defaultFormat;
    
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number === null) return 0;
      
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : '';
      
      return dollarsAmount + centsAmount;
    }
    
    switch (format.match(placeholderRegex)?.[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    
    return format.replace(placeholderRegex, value);
  }

  // 获取购物车数据
  async function getCart() {
    try {
      const response = await fetch(`${CONFIG.routes.cart}?t=${Date.now()}`, {
        credentials: 'same-origin',
        method: 'GET'
      });
      return await response.json();
    } catch (error) {
      console.error('获取购物车失败:', error);
      throw error;
    }
  }

  // 429/网络抖动这类瞬时问题几乎总能在几次退避重试内恢复，跟 variant-migration.js
  // 的 fetchWithRetry 用同样的思路（指数退避），避免只重试一次、固定延迟不够长导致
  // 放弃——这正是"加购/迁移后顶部购物车数量不显示，刷新又恢复正常"的根因之一
  async function getCartWithRetry(maxAttempts) {
    maxAttempts = maxAttempts || 3;
    let lastError;
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        return await getCart();
      } catch (error) {
        lastError = error;
        if (attempt < maxAttempts) {
          const delayMs = 800 * Math.pow(2, attempt - 1); // 800ms, 1600ms
          await new Promise(resolve => setTimeout(resolve, delayMs));
        }
      }
    }
    throw lastError;
  }

  // 更新购物车商品数量
  async function updateCartItem(key, quantity) {
    try {
      const response = await fetch(`${CONFIG.routes.cartChange}?t=${Date.now()}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });
      
      const cart = await response.json();
      // 失败响应体（比如这一行的 key 在背景里被别的迁移改掉了，Shopify 返回 400）
      // 没有 items 字段，结构跟正常购物车完全不一样，不能当成功返回——调用方会直接
      // 拿它当 cart 用（cart.items.find(...)），对着一个没有 items 的对象取 .find
      // 会抛出让人摸不着头脑的 TypeError，而不是一个能看出"请求本身失败了"的错误
      if (!response.ok) {
        throw new Error(cart.description || cart.message || 'cart change request failed');
      }
      return cart;
    } catch (error) {
      console.error('更新购物车失败:', error);
      throw error;
    }
  }

  // 删除购物车商品
  async function removeCartItem(key) {
    return updateCartItem(key, 0);
  }

  // 使用 Section Rendering API 刷新购物车内容
  //
  // 这是一次整页 HTML 请求（~200KB），跟 /cart.js 不是同一个接口，不会被
  // fetch-interceptor.js 的 SicotasCartSnapshot 缓存覆盖到。而 updateCartDisplay()
  // 每次都会 dispatch 'cart:updated'（fetch-interceptor.js 的 refreshCartSurfaces()
  // 也会），setupCartUpdateListener() 监听到就无条件调一次本函数——一次加购动作背后
  // 经常不止一次写入（比如 add.js 成功后 Klip 优惠券搬运还会再发一次 update.js），
  // 每次写入各自独立触发一次 cart:updated，前后间隔通常只有几百毫秒，会在几秒内连续
  // 打出好几个这个重请求，实测就是这批突发的整页请求把 Shopify 对该访客的限流打满、
  // 导致后续请求接连 429 的根因之一。这里加一层短 TTL：进行中的请求直接复用；刚刷新
  // 完的短时间内再次触发也直接跳过，不再重新发请求——跟 SicotasCartSnapshot 对
  // /cart.js 的处理是同一个思路
  const REFRESH_SECTION_TTL_MS = 1500;
  let refreshCartSectionPromise = null;
  let refreshCartSectionAt = 0;
  async function refreshCartSection() {
    if (refreshCartSectionPromise) return refreshCartSectionPromise;
    if (Date.now() - refreshCartSectionAt < REFRESH_SECTION_TTL_MS) return;
    refreshCartSectionPromise = (async () => {
      try {
        const response = await fetch(`/cart?section_id=ecom-new-cart-page-cart&t=${Date.now()}`);
        const html = await response.text();

        // 解析返回的 HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // 查找新的购物车商品列表
        const newCartItems = tempDiv.querySelector('#new-cart-items');
        const currentCartItems = document.querySelector('#new-cart-items');

        if (newCartItems && currentCartItems) {
          currentCartItems.innerHTML = newCartItems.innerHTML;
        }
      } catch (error) {
        console.error('刷新购物车 Section 失败:', error);
      } finally {
        refreshCartSectionAt = Date.now();
        refreshCartSectionPromise = null;
      }
    })();
    return refreshCartSectionPromise;
  }

  // 更新页面上的购物车显示
  function updateCartDisplay(cart) {
    // 更新 Subtotal 标题中的商品数量（bundle作为一个商品统计）
    const subtotalTitle = document.querySelector(CONFIG.selectors.subtotalTitle);
    if (subtotalTitle) {
      // 计算正确的商品数量：bundle作为一个商品统计
      let displayedItemCount = 0;
      const countedBundleIds = new Set();
      
      cart.items.forEach(item => {
        const isBundleItem = item.properties && item.properties._bundle === 'true';
        const bundleId = item.properties && item.properties._bundle_id;
        
        if (isBundleItem && bundleId) {
          if (!countedBundleIds.has(bundleId)) {
            countedBundleIds.add(bundleId);
            displayedItemCount += item.quantity;
          }
        } else {
          displayedItemCount += item.quantity;
        }
      });
      
      // 保持原有格式 "Subtotal ( X Items )"
      subtotalTitle.textContent = `Subtotal ( ${displayedItemCount} Items )`;
      
      // 更新顶部导航购物车数量
      updateHeaderCartCount(displayedItemCount);
    }
    
    // 渲染折扣标签
    renderDiscountTags(cart);
    
    // 更新总价 (Total)
    const totalPrice = document.querySelector(CONFIG.selectors.cartTotal);
    if (totalPrice) {
      totalPrice.textContent = formatMoney(cart.total_price);
    }
    
    // 计算正确的 Retail Price（考虑套餐的真正划线价）
    const { correctRetailPrice } = calculateCorrectPrices(cart);
    
    // 更新原价 (Subtotal = 划线价合计)
    const originalTotal = document.querySelector(CONFIG.selectors.cartOriginalTotal);
    if (originalTotal) {
      originalTotal.textContent = formatMoney(correctRetailPrice);
    }
    
    // 计算 Discount = 折扣码优惠 = 零售价(original_total_price) - 成交价(total_price)
    const discountCodeAmount = cart.original_total_price - cart.total_price;
    const discountRow = document.getElementById('cart-page-discount-row');
    const discountAmountEl = document.getElementById('cart-page-discount-amount');
    if (discountCodeAmount > 0) {
      if (discountAmountEl) {
        discountAmountEl.textContent = '-' + formatMoney(discountCodeAmount);
      }
      if (discountRow) {
        discountRow.style.display = '';
      }
    } else {
      if (discountRow) {
        discountRow.style.display = 'none';
      }
    }
    
    // 计算 You Save = 总节省 = 商品折扣 + 折扣码优惠
    // 商品折扣 = 划线价合计 - 原价合计（不包含折扣码）
    const productDiscount = correctRetailPrice - cart.original_total_price;
    // You Save = 商品折扣 + 折扣码优惠
    const youSaveAmount = productDiscount + discountCodeAmount;
    const youSaveRow = document.getElementById('cart-page-yousave-row');
    const youSaveAmountEl = document.getElementById('cart-page-yousave-amount');
    if (youSaveAmount > 0) {
      if (youSaveAmountEl) {
        youSaveAmountEl.textContent = '-' + formatMoney(youSaveAmount);
      }
      if (youSaveRow) {
        youSaveRow.style.display = '';
      }
    } else {
      if (youSaveRow) {
        youSaveRow.style.display = 'none';
      }
    }
    
    // 更新 data 属性供其他脚本使用
    const checkoutWrapper = document.querySelector('.checkout-sticky-wrapper');
    if (checkoutWrapper) {
      checkoutWrapper.setAttribute('data-correct-retail', correctRetailPrice);
      checkoutWrapper.setAttribute('data-discount-code', discountCodeAmount);
      checkoutWrapper.setAttribute('data-you-save', youSaveAmount);
    }
    
    // 触发自定义事件，让其他组件可以监听
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }
  
  // 计算正确的 Retail Price 和 Saved（考虑套餐的真正划线价）
  function calculateCorrectPrices(cart) {
    let correctRetailPrice = 0;
    let correctTotalPrice = 0;
    const processedBundleIds = new Set();
    
    for (const item of cart.items) {
      const props = item.properties || {};
      const bundleId = props._bundle_id;
      const isBundle = props._bundle === 'true';
      
      if (isBundle && bundleId) {
        // 套餐商品：检查是否已处理过这个 bundle
        if (!processedBundleIds.has(bundleId)) {
          // 收集这个 bundle 的信息
          let bundleMainComparePrice = 0;
          let bundleMainPrice = 0;
          let bundleTotalPrice = 0;
          let bundleQuantity = 1;
          
          for (const bundleItem of cart.items) {
            const biProps = bundleItem.properties || {};
            if (biProps._bundle_id === bundleId) {
              bundleTotalPrice += bundleItem.final_line_price;
              if (biProps._bundle_index === '0') {
                bundleQuantity = bundleItem.quantity;
              }
              if (!bundleMainComparePrice && biProps._bundle_main_compare_price) {
                bundleMainComparePrice = parseFloat(biProps._bundle_main_compare_price) || 0;
              }
              if (!bundleMainPrice && biProps._bundle_main_price) {
                bundleMainPrice = parseFloat(biProps._bundle_main_price) || 0;
              }
            }
          }
          
          // 计算套餐的正确原价（使用 Math.round 确保整数 cents）
          let bundleOriginal = 0;
          if (bundleMainComparePrice > 0) {
            bundleOriginal = Math.round(bundleMainComparePrice * bundleQuantity);
          } else if (bundleMainPrice > 0) {
            bundleOriginal = Math.round(bundleMainPrice * bundleQuantity);
          }
          
          correctRetailPrice += bundleOriginal;
          correctTotalPrice += bundleTotalPrice;
          processedBundleIds.add(bundleId);
        }
      } else {
        // 普通商品：优先使用 compare_at_price，如果没有则使用 original_line_price
        let compareAtPrice = item.variant?.compare_at_price || item.compare_at_price;
        
        // Cart API可能不返回compare_at_price，从DOM读取
        if (!compareAtPrice) {
          const itemRow = document.querySelector(`.static-cart__row[data-key="${item.key}"]`);
          if (itemRow && itemRow.dataset.compareAtPrice) {
            const parsed = parseFloat(itemRow.dataset.compareAtPrice);
            if (!isNaN(parsed) && parsed > 0) {
              compareAtPrice = parsed;
            }
          }
        }
        
        if (compareAtPrice && compareAtPrice > item.price) {
          correctRetailPrice += Math.round(compareAtPrice * item.quantity);
        } else {
          correctRetailPrice += item.original_line_price;
        }
        correctTotalPrice += item.final_line_price;
      }
    }
    
    const correctSavedAmount = correctRetailPrice - correctTotalPrice;
    return { correctRetailPrice, correctSavedAmount };
  }

  // 更新单个商品行的显示
  function updateItemRow(row, item) {
    if (!item) {
      // 商品已被删除，移除整行
      const divider = row.nextElementSibling;
      if (divider && divider.classList.contains('static-cart__divider')) {
        divider.remove();
      }
      row.remove();
      return;
    }
    
    // 更新数量输入框
    const quantityInput = row.querySelector(CONFIG.selectors.quantityInput);
    if (quantityInput) {
      quantityInput.value = item.quantity;
    }
    
    // 更新单价（Price列）
    // Price 列始终显示原价：如果有划线价(compare_at_price)显示它，否则显示 final_price
    const priceEl = row.querySelector('.static-cart__price-current');
    if (priceEl) {
      let displayPrice = item.final_price; // 默认显示原价
      
      // 优先显示划线价
      let compareAtPrice = item.compare_at_price || (item.variant && item.variant.compare_at_price);
      if (!compareAtPrice && row.dataset.compareAtPrice) {
        compareAtPrice = parseFloat(row.dataset.compareAtPrice);
      }
      
      if (compareAtPrice && compareAtPrice > item.final_price) {
        displayPrice = compareAtPrice;
      }
      
      priceEl.textContent = formatMoney(displayPrice);
    }
    
    // 更新总价（黑色价格）- 使用 line_price（实际支付价格）
    const totalEl = row.querySelector('.static-cart__total .static-cart__price-final');
    if (totalEl) {
      totalEl.textContent = formatMoney(item.line_price);
    }
    
    // 更新划线价和折扣 - 优先使用 compare_at_price
    const oldPriceEl = row.querySelector('.static-cart__total .static-cart__price-old');
    let compareAtPrice = item.compare_at_price || (item.variant && item.variant.compare_at_price);
    
    // 如果Cart API没有返回，从data属性读取
    if (!compareAtPrice && row.dataset.compareAtPrice) {
      compareAtPrice = parseFloat(row.dataset.compareAtPrice);
    }
    
    if (compareAtPrice && compareAtPrice > item.price) {
      // 有 compare_at_price，使用它作为划线价（乘以数量）
      const lineCompareAt = Math.round(compareAtPrice * item.quantity);
      if (oldPriceEl) {
        oldPriceEl.textContent = formatMoney(lineCompareAt);
        oldPriceEl.style.display = ''; // 确保显示
      }
      
      // 使用 original_line_price（折扣码前的价格）来计算商品本身的折扣
      // 这样Save金额只显示商品折扣，不包含折扣码
      const priceForSavings = item.original_line_price || item.line_price;
      const savings = lineCompareAt - priceForSavings;
      const savingsPercent = Math.round((savings / lineCompareAt) * 100);
      
      // 更新 PC 端折扣显示
      const saleDesktopEls = row.querySelectorAll('.static-cart__total .static-cart__price-sale--desktop');
      if (saleDesktopEls.length >= 2) {
        saleDesktopEls[0].textContent = `(-${savingsPercent}%)`;
        saleDesktopEls[1].textContent = `(Save ${formatMoney(savings)})`;
      }
      
      // 更新移动端折扣显示
      const saveMobileEl = row.querySelector('.static-cart__savings-mobile .static-cart__price-sale');
      if (saveMobileEl) {
        saveMobileEl.textContent = `(-${savingsPercent}% Save ${formatMoney(savings)})`;
      }
    } else if (item.line_price !== item.final_line_price) {
      // 有折扣码：显示 final_line_price（原价）作为划线价
      console.log('🔍 折扣码分支 - 更新商品:', item.key);
      console.log('  - line_price:', item.line_price, formatMoney(item.line_price));
      console.log('  - final_line_price:', item.final_line_price, formatMoney(item.final_line_price));
      console.log('  - discounts:', item.discounts);
      
      if (oldPriceEl) {
        oldPriceEl.textContent = formatMoney(item.final_line_price);
        oldPriceEl.style.display = ''; // 确保显示
      }
      
      const savings = item.final_line_price - item.line_price;
      const savingsPercent = Math.round((savings / item.final_line_price) * 100);
      
      console.log('  - savings:', savings, formatMoney(savings));
      console.log('  - savingsPercent:', savingsPercent);
      
      // 注意：对于折扣码，不更新 price-sale 元素，因为它们在Liquid里不存在
      // 而是更新 discount-amount-text 元素
      
      // 更新折扣标签和金额
      if (item.discounts && item.discounts.length > 0) {
        const totalDiscountAmount = item.discounts.reduce((sum, d) => sum + d.amount, 0);
        console.log('  - totalDiscountAmount:', totalDiscountAmount, formatMoney(totalDiscountAmount));
        
        // 直接在row里查找，不用data-item-key（因为key的哈希值会变）
        const tagContainers = row.querySelectorAll('.static-cart__discount-tags-container');
        console.log('  - 找到 tagContainers:', tagContainers.length);
        
        tagContainers.forEach(container => {
          console.log('  - 更新容器的 data-item-key 从', container.dataset.itemKey, '到', item.key);
          container.dataset.itemKey = item.key; // 更新key
          container.innerHTML = '';
          item.discounts.forEach(discount => {
            const tag = document.createElement('span');
            tag.className = 'static-cart__discount-tag static-cart__discount-tag--desktop';
            tag.title = discount.title;
            
            const displayTitle = discount.title.length > 15 
              ? discount.title.substring(0, 15) + '...' 
              : discount.title;
            
            tag.innerHTML = `
              <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 12 12" style="width: 10px; height: 10px; margin-right: 4px;">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 17 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
              </svg>
              ${displayTitle}
            `;
            container.appendChild(tag);
          });
        });
        
        // 直接在row里查找折扣金额文本
        const amountContainers = row.querySelectorAll('.static-cart__discount-amount-text');
        console.log('  - 找到 amountContainers:', amountContainers.length);
        
        amountContainers.forEach(container => {
          console.log('  - 更新容器的 data-item-key 从', container.dataset.itemKey, '到', item.key);
          container.dataset.itemKey = item.key; // 更新key
          const saveText = `(Save ${formatMoney(totalDiscountAmount)})`;
          console.log('  - 设置文本:', saveText);
          container.textContent = saveText;
        });
      }
    } else if (item.original_line_price !== item.final_line_price) {
      // 变体折扣：使用 original_line_price
      if (oldPriceEl) {
        oldPriceEl.textContent = formatMoney(item.original_line_price);
        oldPriceEl.style.display = '';
      }
      
      const savings = item.original_line_price - item.line_price;
      const savingsPercent = Math.round((savings / item.original_line_price) * 100);
      
      // 更新 PC 端折扣显示
      const saleDesktopEls = row.querySelectorAll('.static-cart__total .static-cart__price-sale--desktop');
      if (saleDesktopEls.length >= 2) {
        saleDesktopEls[0].textContent = `(-${savingsPercent}%)`;
        saleDesktopEls[1].textContent = `(Save ${formatMoney(savings)})`;
      }
      
      // 更新移动端折扣显示
      const saveMobileEl = row.querySelector('.static-cart__savings-mobile .static-cart__price-sale');
      if (saveMobileEl) {
        saveMobileEl.textContent = `(-${savingsPercent}% Save ${formatMoney(savings)})`;
      }
    } else {
      // 没有任何折扣，隐藏划线价
      if (oldPriceEl) {
        oldPriceEl.style.display = 'none';
      }
    }
  }

  // 处理数量变化
  // delta：+/- 按钮点击时传进来的增量（+1/-1）。点击那一刻 newQuantity 是从 DOM 当场
  // 读出来的旧值算出来的，如果背景迁移（variant-migration.js/fetch-interceptor.js）刚好
  // 在这段时间并过这一行的数量，DOM 上显示的还是并之前的旧值，拿它做基准直接覆盖会把刚并
  // 进来的数量冲掉——这里传了 delta 的调用会改成拿到锁之后现读一次最新数量再加/减，
  // 而不是相信调用方传进来的 newQuantity（该值仅在拿不到最新数量时当兜底用）。直接输入框
  // 打字/删除按钮不传 delta：用户这两种操作的意图本来就是"设成这个绝对值"，不需要重新对齐
  async function handleQuantityChange(key, newQuantity, row, delta) {
    // 如果正在处理中，直接返回
    if (row.dataset.updating === 'true') return;

    // key 为空说明这一行的 data-key 跟服务端已经不同步了（比如背景迁移改写了这一行
    // 但 DOM 还没刷新过来）——不管具体原因是什么，带着空 key 发请求给 /cart/change.js
    // 必然是 "no valid id or line parameter" 400，纯属浪费一次请求、还会把用户操作
    // 的数量吞掉。这里直接不发，先刷新拿到最新购物车、把这一行的 key 重新同步上，
    // 让用户可以再操作一次，而不是先发一个注定失败的请求再来擦屁股
    if (!key) {
      console.warn('[cart-page-new] quantity change aborted: row key is empty, resyncing from server');
      try {
        // 不按 lineIndex（页面渲染时的静态位置，"forloop.index"）去猜这一行现在对应
        // 购物车里的哪个商品——背景迁移改写/合并某一行、或任何一行被删除，都会让后面
        // 所有行的实际位置跟渲染时的位置错位。猜错的话会把"别的商品"的 key 焊到这一行
        // DOM 上，用户之后点这一行的 +/- 实际改的是别的商品，这正是"改一个商品数量、
        // 另一个商品也跟着变"的根因。位置不可信时，用 Section Rendering API 整体刷新，
        // 让每一行都按服务端返回的真实 key 重新对齐，才是唯一安全的做法
        await refreshCartSection();
      } catch (error) {
        console.error('[cart-page-new] failed to resync row key:', error);
      }
      return;
    }

    row.dataset.updating = 'true';
    
    // 显示 loading 指示器（覆盖在数量选择器上方）
    const quantityEl = row.querySelector('.static-cart__quantity');
    let spinner = null;
    if (quantityEl) {
      spinner = document.createElement('span');
      spinner.className = 'cart-spinner';
      spinner.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6D4C41" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-opacity="0.2"/><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.6s" repeatCount="indefinite"/></path></svg>';
      quantityEl.style.position = 'relative';
      quantityEl.appendChild(spinner);
    }
    
    try {
      // 整段"读基准数量 + 写请求"都放进跟背景迁移共用的同一把锁里排队：不这样做的话，
      // 锁只能防住"两次写各自都基于自己那份快照互相覆盖"，防不住"我方基准数量都读完了，
      // 对方才插进来写"这种更窄的窗口
      await window.SicotasCartLineLock.run(key, async () => {
        // +/- 按钮点击（带 delta）：不信任点击那一刻从 DOM 读到的 newQuantity，现读一次
        // 最新数量做基准再加/减，避免背景迁移刚并过的数量被这次点击用旧值覆盖掉
        let effectiveQuantity = newQuantity;
        if (typeof delta === 'number') {
          try {
            const latestCart = await getCart();
            // 只信 key 精确匹配——不再退化成按 lineIndex（静态位置）猜一个"差不多的"
            // 商品当基准，猜错会拿着别的商品的数量去加/减，参见下面按 key 找不到
            // updatedItem 时的同款注释
            const latestItem = latestCart.items.find(item => item.key === key);
            if (latestItem) {
              effectiveQuantity = Math.max(0, Math.min(30, latestItem.quantity + delta));
            }
          } catch (error) {
            // 拿不到最新数量就退回调用方传进来的值，好过完全不处理这次点击
          }
        }

        const cart = await updateCartItem(key, effectiveQuantity);

        // 购物车整个清空后，section 会切换成结构完全不同的"空购物车"布局
        // （sections/ecom-new-cart-page-cart.liquid 里 `cart == empty` 分支，order
        // summary/checkout 面板一并消失），局部替换 #new-cart-items 覆盖不了这种
        // 结构性切换，只有整页刷新才能拿到正确的空态，这一种情况仍然保留整页刷新
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        // 数量为0（删除商品）：跟拆分迁移用同一套局部刷新——Section Rendering API
        // 重新拉取商品行列表 + updateCartDisplay 重算汇总金额，不再整页刷新，
        // 避免打断同一时刻用户对其它行发起的、尚未完成的请求
        if (effectiveQuantity === 0) {
          await refreshCartSection();
          updateCartDisplay(cart);
          return;
        }

        // 只信 key 精确匹配这一行更新后的商品
        const updatedItem = cart.items.find(item => item.key === key);

        if (!updatedItem) {
          // 找不到：可能真的被删除了，也可能是 effectiveQuantity 变化触发 Shopify
          // 把这一行合并进了另一条已存在的行。以前这里会退化成按 lineIndex（页面渲染
          // 时的静态位置）去 cart.items 里"猜"一个商品当作 updatedItem，然后把它的
          // key 写回这一行的 data-key——一旦背景迁移/其它行被删除导致位置错位，猜到
          // 的其实是另一个毫不相干的商品，这一行从此就"焊"上了别的商品的 key，用户
          // 之后点这一行的 +/- 实际改的是别的商品，这正是"改一个商品数量、另一个商品
          // 也跟着变"的根因。位置不可信时，用 Section Rendering API 整体刷新，让每
          // 一行都按服务端返回的真实数据重新对齐，才是唯一安全的做法
          await refreshCartSection();
        } else {
          // 更新商品行
          updateItemRow(row, updatedItem);

          // 更新行的 data 属性（以防 key 发生变化）
          row.dataset.key = updatedItem.key;

          // 更新所有按钮和输入框的 data-key
          row.querySelectorAll('[data-key]').forEach(el => {
            el.dataset.key = updatedItem.key;
          });
        }

        // 更新整体购物车显示
        updateCartDisplay(cart);
      });
    } catch (error) {
      console.error('更新数量失败:', error);
      // 这里失败最常见的原因不是网络问题，而是这一行的 key 在背景里被别的迁移
      // 改掉了（比如"并数量"逻辑重写了这一行，Shopify 给它生成了新的 key），
      // 页面上按钮/输入框还记着旧 key，Shopify 直接 400。以前这里会退化成按
      // row.dataset.line（页面渲染时的静态位置）直接从最新购物车里按下标取一个
      // 商品，不做任何 key 校验就把它的 key/数量焊到这一行上——只要背景迁移/其它
      // 行被删除导致位置跟服务端实际顺序错位，取到的就是完全不相关的另一个商品，
      // 这正是"改一个商品数量、另一个商品也跟着变"的根因。位置不可信时，用
      // Section Rendering API 整体刷新，让每一行都按服务端返回的真实 key/数量
      // 重新对齐，才是唯一安全的恢复方式
      try {
        await refreshCartSection();
      } catch (refreshError) {
        console.error('恢复购物车行状态失败:', refreshError);
      }
    } finally {
      // 移除 spinner
      if (spinner) {
        spinner.remove();
      }
      row.dataset.updating = 'false';
    }
  }

  // 绑定事件
  function bindEvents() {
    const cartContainer = document.querySelector(CONFIG.selectors.cartContainer);
    if (!cartContainer) return;

    // 使用事件委托
    cartContainer.addEventListener('click', async (e) => {
      const target = e.target;
      
      // 处理 Bundle 增减按钮点击 - 新版 (data-action="increase-bundle" / "decrease-bundle")
      const bundleActionBtn = target.closest('[data-action="increase-bundle"], [data-action="decrease-bundle"]');
      if (bundleActionBtn) {
        e.preventDefault();
        
        const bundleId = bundleActionBtn.dataset.bundleId;
        if (!bundleId) return;
        
        const bundleGroup = bundleActionBtn.closest('.static-cart__bundle-group');
        const input = bundleGroup.querySelector('.static-cart__quantity-input');
        let quantity = parseInt(input.value, 10);
        
        if (bundleActionBtn.dataset.action === 'increase-bundle') {
          // 检查是否已达到30的硬限制
          if (quantity >= 30) {
            bundleActionBtn.classList.add('is-disabled');
            bundleActionBtn.disabled = true;
            return;
          }
          quantity += 1;
          // 如果增加后达到30的硬限制，禁用按钮
          if (quantity >= 30) {
            bundleActionBtn.classList.add('is-disabled');
            bundleActionBtn.disabled = true;
          }
        } else if (bundleActionBtn.dataset.action === 'decrease-bundle') {
          quantity = Math.max(0, quantity - 1);
          // 减少后，启用增加按钮
          const increaseBtn = bundleGroup.querySelector('[data-action="increase-bundle"]');
          if (increaseBtn && quantity < 30) {
            increaseBtn.classList.remove('is-disabled');
            increaseBtn.disabled = false;
          }
        }
        
        input.value = quantity;
        // 传 delta：真正发给服务器的数量在 handleBundleQuantityChangeById 里会现读
        // 最新值重新加/减一次，quantity 这里只用作乐观 UI/兜底值
        await handleBundleQuantityChangeById(bundleId, quantity, bundleGroup, bundleActionBtn.dataset.action === 'increase-bundle' ? 1 : -1);
        return;
      }

      // 处理 Bundle 删除按钮点击 - 新版 (data-action="remove-bundle")
      const bundleRemoveActionBtn = target.closest('[data-action="remove-bundle"]');
      if (bundleRemoveActionBtn) {
        e.preventDefault();
        
        const bundleId = bundleRemoveActionBtn.dataset.bundleId;
        if (!bundleId) return;
        
        const bundleGroup = bundleRemoveActionBtn.closest('.static-cart__bundle-group');
        await handleBundleQuantityChangeById(bundleId, 0, bundleGroup);
        return;
      }
      
      // 处理 Bundle 增减按钮点击 - 旧版兼容
      const bundleBtn = target.closest('.static-cart__bundle .static-cart__quantity-btn');
      if (bundleBtn) {
        e.preventDefault();
        
        const bundleEl = bundleBtn.closest('.static-cart__bundle');
        const quantityWrapper = bundleBtn.closest('.static-cart__quantity');
        const input = quantityWrapper.querySelector('.static-cart__quantity-input');
        const bundleKeys = quantityWrapper.dataset.bundleKeys ? quantityWrapper.dataset.bundleKeys.split(',') : [];
        
        let quantity = parseInt(input.value, 10);
        
        if (bundleBtn.dataset.action === 'bundle-increase') {
          quantity += 1;
        } else if (bundleBtn.dataset.action === 'bundle-decrease') {
          quantity = Math.max(0, quantity - 1);
        }
        
        input.value = quantity;
        // 传 delta，原因同上
        await handleBundleQuantityChange(bundleKeys, quantity, bundleEl, bundleBtn.dataset.action === 'bundle-increase' ? 1 : -1);
        return;
      }

      // 处理 Bundle 删除按钮点击 - 旧版兼容
      const bundleRemoveBtn = target.closest('.static-cart__bundle-remove');
      if (bundleRemoveBtn) {
        e.preventDefault();
        
        const bundleEl = bundleRemoveBtn.closest('.static-cart__bundle');
        const bundleKeys = bundleRemoveBtn.dataset.bundleKeys ? bundleRemoveBtn.dataset.bundleKeys.split(',') : [];
        
        await handleBundleQuantityChange(bundleKeys, 0, bundleEl);
        return;
      }
      
      // 处理增减按钮点击
      const btn = target.closest(CONFIG.selectors.quantityBtn);
      if (btn) {
        e.preventDefault();
        
        const row = btn.closest(CONFIG.selectors.cartRow);
        const input = row.querySelector(CONFIG.selectors.quantityInput);
        const key = btn.dataset.key || input.dataset.key;
        let quantity = parseInt(input.value, 10);
        
        if (btn.dataset.action === 'increase') {
          // 检查是否已达到30的硬限制
          if (quantity >= 30) {
            showStockWarning(row, 'Insufficient Stock');
            btn.classList.add('is-disabled');
            btn.disabled = true;
            return;
          }
          // 检查是否已达到库存上限
          const maxQty = parseInt(btn.dataset.maxQty, 10);
          if (maxQty && !isNaN(maxQty) && quantity >= maxQty) {
            // 已达到库存上限，显示警告并禁用按钮
            showStockWarning(row, `Max ${maxQty} in stock`);
            btn.classList.add('is-disabled');
            btn.disabled = true;
            return;
          }
          quantity += 1;
          // 如果增加后达到30的硬限制，禁用按钮并显示警告
          if (quantity >= 30) {
            showStockWarning(row, 'Insufficient Stock');
            btn.classList.add('is-disabled');
            btn.disabled = true;
          }
          // 如果增加后达到库存上限，禁用按钮
          else if (maxQty && !isNaN(maxQty) && quantity >= maxQty) {
            btn.classList.add('is-disabled');
            btn.disabled = true;
          }
          // 增加后，如果数量 > 1，启用减号按钮
          if (quantity > 1) {
            const decreaseBtn = row.querySelector('[data-action="decrease"]');
            if (decreaseBtn) {
              decreaseBtn.classList.remove('is-disabled');
              decreaseBtn.disabled = false;
            }
          }
        } else if (btn.dataset.action === 'decrease') {
          quantity = Math.max(0, quantity - 1);
          // 减少后，启用增加按钮
          const increaseBtn = row.querySelector('[data-action="increase"]');
          if (increaseBtn) {
            increaseBtn.classList.remove('is-disabled');
            increaseBtn.disabled = false;
          }
          // 减少后，如果数量 <= 1，禁用减号按钮
          if (quantity <= 1) {
            btn.classList.add('is-disabled');
            btn.disabled = true;
          }
        }
        
        input.value = quantity;
        // +/- 按钮传 delta：这里算出的 quantity 只是给点击那一刻的乐观 UI/库存上限判断用，
        // 真正发给服务器的数量在 handleQuantityChange 里会现读最新值重新加/减一次，
        // 避免用这份可能已经过期的 DOM 值覆盖掉背景迁移刚并进来的数量
        handleQuantityChange(key, quantity, row, btn.dataset.action === 'increase' ? 1 : -1);
        return;
      }

      // 处理删除按钮点击
      const removeBtn = target.closest(CONFIG.selectors.removeBtn);
      if (removeBtn) {
        e.preventDefault();

        const row = removeBtn.closest(CONFIG.selectors.cartRow);
        const key = removeBtn.dataset.key;

        if (key) {
          handleQuantityChange(key, 0, row);
        }
        return;
      }
    });

    // 处理数量输入框变化
    const debouncedInputHandler = debounce(async (e) => {
      const input = e.target;
      if (!input.matches(CONFIG.selectors.quantityInput)) return;

      // 检查是否是 Bundle 输入框
      const bundleId = input.dataset.bundleId;
      if (bundleId) {
        const bundleGroup = input.closest('.static-cart__bundle-group');
        const quantity = parseInt(input.value, 10) || 0;
        await handleBundleQuantityChangeById(bundleId, quantity, bundleGroup);
        return;
      }

      const row = input.closest(CONFIG.selectors.cartRow);
      const key = input.dataset.key;
      const quantity = parseInt(input.value, 10) || 0;

      handleQuantityChange(key, quantity, row);
    }, CONFIG.debounceDelay);

    cartContainer.addEventListener('change', debouncedInputHandler);
    
    // 处理 Save for Wishlist 按钮点击
    cartContainer.addEventListener('click', async (e) => {
      const wishlistBtn = e.target.closest('[data-action="wishlist"]');
      if (wishlistBtn) {
        e.preventDefault();
        await handleSaveForWishlist(wishlistBtn);
        return;
      }
      
      const wishlistBundleBtn = e.target.closest('[data-action="wishlist-bundle"]');
      if (wishlistBundleBtn) {
        e.preventDefault();
        await handleSaveForWishlistBundle(wishlistBundleBtn);
        return;
      }
    });
    
    // 处理 Checkout 按钮 - 将折扣码附加到 checkout URL
    setupCheckoutWithDiscount();
  }
  
  // 获取或创建心愿单文件夹
  async function getOrCreateWishlistFolder(customerId) {
    const baseUrl = 'https://wishlist.webcontrive.com/wishlist-club/public';
    const token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3dpc2hsaXN0LndlYmNvbnRyaXZlLmNvbS93aXNobGlzdC1jbHViL3B1YmxpYyIsImlhdCI6MTc2NTg4MzU4MiwibmJmIjoxNzY1ODgzNTgyLCJleHAiOjE3OTc0MTk1ODIsInNob3BfaWQiOjQxODF9.B3w22Jpa5klhom2uJVjP3XapvnCLTDhmSuequs_rQTY';
    const shop = 'sicotas.myshopify.com';
    
    try {
      // 尝试获取现有心愿单
      const getUrl = `${baseUrl}/api/v3/get`;
      const getResponse = await fetch(getUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
          'Authorization': token
        },
        body: JSON.stringify({
          customer_id: String(customerId),
          ip: null,
          shop: shop
        })
      });
      
      const data = await getResponse.json();
      
      if (data.status === 200 && data.data?.wishlists?.length > 0) {
        return data.data.wishlists[0].id;
      }
      
      // 如果没有心愿单，创建一个
      const createUrl = `${baseUrl}/api/v3/wishlist`;
      const createResponse = await fetch(createUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
          'Authorization': token
        },
        body: JSON.stringify({
          shop: shop,
          name: 'My Wishlist',
          customer_id: String(customerId),
          ip: null
        })
      });
      
      const createData = await createResponse.json();
      
      if (createData.status === 200 && createData.data?.id) {
        return createData.data.id;
      }
      
      throw new Error('Failed to create wishlist folder');
    } catch (error) {
      console.error('❌ getOrCreateWishlistFolder error:', error);
      return null;
    }
  }
  
  // 获取当前心愿单数量
  async function getWishlistItemCount(customerId) {
    try {
      // 使用正确的API：/api/v3/get (POST请求)
      const url = 'https://wishlist.webcontrive.com/wishlist-club/public/api/v3/get';
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
          'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3dpc2hsaXN0LndlYmNvbnRyaXZlLmNvbS93aXNobGlzdC1jbHViL3B1YmxpYyIsImlhdCI6MTc2NTg4MzU4MiwibmJmIjoxNzY1ODgzNTgyLCJleHAiOjE3OTc0MTk1ODIsInNob3BfaWQiOjQxODF9.B3w22Jpa5klhom2uJVjP3XapvnCLTDhmSuequs_rQTY'
        },
        body: JSON.stringify({
          shop: 'sicotas.myshopify.com',
          customer_id: String(customerId),
          ip: null
        })
      });
      
      if (!response.ok) {
        console.log('⚠️ Wishlist API failed, returning 0 count');
        return 0;
      }
      
      const data = await response.json();
      
      // API返回格式：{ status: 200, data: { total: 5, wishlists: [...] } }
      if (data.status === 200 && data.data) {
        return data.data.total || 0;
      }
      
      return 0;
    } catch (error) {
      console.error('❌ 获取心愿单数量失败:', error);
      return 0;
    }
  }
  
  // 处理普通商品保存到心愿单
  async function handleSaveForWishlist(button) {
    const variantId = button.dataset.variantId;
    const productId = button.dataset.productId;
    const itemKey = button.dataset.itemKey;
    const customerId = window.__st?.cid || null;
    
    if (!variantId || !productId || !itemKey) {
      console.error('❌ Missing required data');
      return;
    }
    
    if (!customerId) {
      console.error('❌ No customer ID found');
      alert('Please log in to save items to wishlist');
      return;
    }
    
    button.disabled = true;
    button.textContent = 'Saving...';
    
    try {
      // 获取动态 wishlistId
      const wishlistId = await getOrCreateWishlistFolder(customerId);
      if (!wishlistId) {
        throw new Error('Failed to get wishlist folder');
      }
      
      // 检查心愿单数量限制（只对登录用户检查）
      if (customerId) {
        const currentCount = await getWishlistItemCount(customerId);
        if (currentCount >= 30) {
          alert('You have reached the maximum of 30 items in your wishlist');
          button.disabled = false;
          button.textContent = 'Save for Wishlist';
          return;
        }
      }
      
      // 1. 添加到心愿单 - 使用动态的 wishlistId
      const response = await fetch('https://wishlist.webcontrive.com/wishlist-club/public/api/v3/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
          'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3dpc2hsaXN0LndlYmNvbnRyaXZlLmNvbS93aXNobGlzdC1jbHViL3B1YmxpYyIsImlhdCI6MTc2NTg4MzU4MiwibmJmIjoxNzY1ODgzNTgyLCJleHAiOjE3OTc0MTk1ODIsInNob3BfaWQiOjQxODF9.B3w22Jpa5klhom2uJVjP3XapvnCLTDhmSuequs_rQTY'
        },
        body: JSON.stringify({
          customer_id: customerId ? String(customerId) : null,
          ip: null,
          shop: 'sicotas.myshopify.com',
          wishlist_id: wishlistId,
          product_id: productId,
          variant_id: variantId
        })
      });
      
      const data = await response.json();
      if (data.status === 200) {
        // 2. 从购物车移除。走同一把 SicotasCartLineLock 排队，避免正好跟背景迁移
        // 对同一个 key 的并数量写入撞在一起（这里反正紧接着整页刷新，不排队也不会丢
        // 数据，纯粹是让这次移除跟其它写入之间有个确定的先后顺序，不留中间态）
        await window.SicotasCartLineLock.run(itemKey, () => fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
        }));

        // 3. 刷新页面
        window.location.reload();
      } else if (data.status === 422 || data.message?.includes('already')) {
        // 商品已在心愿单中，仍然从购物车移除
        await window.SicotasCartLineLock.run(itemKey, () => fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
        }));
        window.location.reload();
      } else {
        throw new Error(data.message || 'Failed to add to wishlist');
      }
    } catch (error) {
      console.error('❌ Failed:', error);
      button.disabled = false;
      button.textContent = 'Save for Wishlist';
      alert('Failed to save. Please try again.');
    }
  }
  
  // 处理Bundle商品保存到心愿单
  async function handleSaveForWishlistBundle(button) {
    const bundleKeys = button.dataset.bundleKeys ? button.dataset.bundleKeys.split(',') : [];
    
    if (bundleKeys.length === 0) {
      console.error('❌ No bundle keys found');
      return;
    }
    
    const customerId = window.__st?.cid || null;
    
    if (!customerId) {
      console.error('❌ No customer ID found');
      alert('Please log in to save items to wishlist');
      return;
    }
    
    button.disabled = true;
    button.textContent = 'Saving...';
    
    try {
      // 获取动态 wishlistId
      const wishlistId = await getOrCreateWishlistFolder(customerId);
      if (!wishlistId) {
        throw new Error('Failed to get wishlist folder');
      }
      
      // 检查心愿单数量限制（只对登录用户检查）
      if (customerId) {
        const currentCount = await getWishlistItemCount(customerId);
        if (currentCount + bundleKeys.length > 30) {
          alert(`Cannot add all items. You can only have up to 30 items in your wishlist. Current: ${currentCount}, Attempting to add: ${bundleKeys.length}`);
          button.disabled = false;
          button.textContent = 'Save for Wishlist';
          return;
        }
      }
      
      // Bundle包含多个商品，需要逐个添加到wishlist
      const cart = await fetch('/cart.js').then(r => r.json());
      
      for (const key of bundleKeys) {
        const item = cart.items.find(i => i.key === key);
        if (item) {
          await fetch('https://wishlist.webcontrive.com/wishlist-club/public/api/v3/add', {
            method: 'POST',
            headers: {
              'Content-Type': 'text/plain',
              'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3dpc2hsaXN0LndlYmNvbnRyaXZlLmNvbS93aXNobGlzdC1jbHViL3B1YmxpYyIsImlhdCI6MTc2NTg4MzU4MiwibmJmIjoxNzY1ODgzNTgyLCJleHAiOjE3OTc0MTk1ODIsInNob3BfaWQiOjQxODF9.B3w22Jpa5klhom2uJVjP3XapvnCLTDhmSuequs_rQTY'
            },
            body: JSON.stringify({
              customer_id: customerId ? String(customerId) : null,
              ip: null,
              shop: 'sicotas.myshopify.com',
              wishlist_id: wishlistId,
              product_id: item.product_id,
              variant_id: item.variant_id
            })
          });
        }
      }
      
      // 从购物车移除所有bundle商品
      for (const key of bundleKeys) {
        await window.SicotasCartLineLock.run(key, () => fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }));
      }
      
      // 刷新页面
      window.location.reload();
    } catch (error) {
      console.error('❌ Failed:', error);
      button.disabled = false;
      button.textContent = 'Save for Wishlist';
      alert('Failed to save bundle. Please try again.');
    }
  }
  
  // 设置 Checkout 按钮以自动附加折扣码到 checkout URL
  function setupCheckoutWithDiscount() {
    // 获取 cookie 中的折扣码
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return '';
    }

    function doCheckoutRedirect() {
      let discountCode = getCookie('discount_code');
      if (!discountCode) {
        const discountInput = document.querySelector('.ecom-cart__coupon--input, input[name="coupon"]');
        if (discountInput) discountCode = discountInput.value.trim();
      }
      window.location.href = discountCode
        ? '/checkout?discount=' + encodeURIComponent(discountCode)
        : '/checkout';
    }

    // 用我们自己的按钮替换 EComposer 的原始按钮
    // 新按钮和 EComposer/Elsklip 完全无关，不受任何第三方逻辑影响
    function replaceCheckoutButtons() {
      const originalBtns = document.querySelectorAll('.ecom-cart__checkout-button--submit');
      originalBtns.forEach(function(original) {
        // 避免重复替换
        if (original.dataset.replaced) return;
        original.dataset.replaced = 'true';

        // 创建我们自己的按钮，样式完全继承原按钮
        const newBtn = document.createElement('button');
        newBtn.type = 'button'; // 不是 submit，不会触发任何 form 逻辑
        newBtn.className = original.className + ' custom-checkout-btn';
        newBtn.innerHTML = original.innerHTML;
        newBtn.onclick = function() {
          if (newBtn.classList.contains('is-loading')) return;
          // 显示 loading 状态
          newBtn.classList.add('is-loading');
          newBtn.disabled = true;
          const textSpan = newBtn.querySelector('.ecom-cart-checkout-text');
          if (textSpan) textSpan.textContent = 'Loading...';
          doCheckoutRedirect();
        };

        // 隐藏原按钮，插入新按钮
        original.style.display = 'none';
        original.parentNode.insertBefore(newBtn, original.nextSibling);
      });
    }

    replaceCheckoutButtons();

    function resetCheckoutButtonState() {
      document.querySelectorAll('.custom-checkout-btn').forEach(function(btn) {
        btn.classList.remove('is-loading', 'btn--loading');
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('aria-busy');

        const textSpan = btn.querySelector('.ecom-cart-checkout-text');
        if (textSpan && textSpan.textContent.trim() === 'Loading...') {
          textSpan.textContent = 'Checkout';
        }
      });
    }

    // 移动端从 Checkout 返回时不一定会把 pageshow.persisted 设为 true。
    // 无论是 bfcache 还是普通历史恢复，都要先恢复按钮的可支付状态。
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        // 页面从 bfcache 恢复，清除替换标记，重新执行
        document.querySelectorAll('.ecom-cart__checkout-button--submit').forEach(function(btn) {
          delete btn.dataset.replaced;
          btn.style.display = '';
        });
        document.querySelectorAll('.custom-checkout-btn').forEach(function(btn) {
          btn.remove();
        });
        replaceCheckoutButtons();
      }
      resetCheckoutButtonState();
    });

    // 部分移动端结账页以同一 WebView 覆盖打开，返回时只会恢复页面可见性。
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible') {
        resetCheckoutButtonState();
      }
    });
  }
  
  // 处理 Bundle 数量变化 - 通过 bundle_id 查找所有相关商品
  // delta：+/- 按钮点击时传进来的增量（+1/-1）；不传时 newQuantity 就是要设置的绝对值
  // （直接输入框打字、删除 Bundle 都是这种用法）。原理跟 handleQuantityChange 一样，
  // 见那边的注释
  async function handleBundleQuantityChangeById(bundleId, newQuantity, bundleGroupEl, delta) {
    if (!bundleId) return;

    // 如果正在处理中，直接返回
    if (bundleGroupEl && bundleGroupEl.dataset.updating === 'true') return;
    if (bundleGroupEl) bundleGroupEl.dataset.updating = 'true';

    // 显示 loading 指示器
    const quantityWrapper = bundleGroupEl ? bundleGroupEl.querySelector('.static-cart__quantity') : null;
    let spinner = null;
    if (quantityWrapper) {
      spinner = document.createElement('span');
      spinner.className = 'cart-spinner';
      spinner.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6D4C41" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-opacity="0.2"/><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.6s" repeatCount="indefinite"/></path></svg>';
      quantityWrapper.style.position = 'relative';
      quantityWrapper.appendChild(spinner);
    }

    try {
      // 首先获取当前购物车，找到所有匹配 bundle_id 的商品
      const cart = await getCart();
      const bundleKeys = [];
      let currentQuantity = 0;

      cart.items.forEach(item => {
        if (item.properties && item.properties._bundle_id === bundleId) {
          bundleKeys.push(item.key);
          if (currentQuantity === 0) currentQuantity = item.quantity;
        }
      });

      if (bundleKeys.length === 0) {
        console.warn('No items found for bundle_id:', bundleId);
        return;
      }

      // Bundle 的几个成员一起写、一起排队：跟单品的 handleQuantityChange 一样，
      // 这一组 key 的数量修改可能同时来自这次点击和背景迁移合并数量，用 runMulti
      // 把所有成员 key 一起锁住，避免其中一个成员被背景迁移单独改掉，导致 Bundle
      // 内几个成员的数量不再一致
      let isIncreasing = newQuantity > currentQuantity;
      let responseOk = true;
      let updatedCart = null;

      await window.SicotasCartLineLock.runMulti(bundleKeys, async () => {
        let targetQuantity = newQuantity;
        if (typeof delta === 'number') {
          // +/- 点击：拿到锁之后现读一次最新数量做基准再加/减，不信任点击那一刻的 DOM 值
          const freshCart = await getCart();
          const freshItem = freshCart.items.find(item => bundleKeys.includes(item.key));
          const baseQuantity = freshItem ? freshItem.quantity : currentQuantity;
          targetQuantity = Math.max(0, Math.min(30, baseQuantity + delta));
          currentQuantity = baseQuantity;
        }
        isIncreasing = targetQuantity > currentQuantity;

        // 构建更新对象
        const updates = {};
        bundleKeys.forEach(key => {
          updates[key] = targetQuantity;
        });

        const response = await fetch(`${CONFIG.routes.cartUpdate}?t=${Date.now()}`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        updatedCart = await response.json();
        responseOk = response.ok;
      });

      // 检查是否有错误
      if (!responseOk || updatedCart.status === 422 || updatedCart.message) {
        const errorMessage = updatedCart.message || updatedCart.description || 'Failed to update quantity';
        // 先显示警告并禁用按钮（在刷新前）
        if (isIncreasing && bundleGroupEl) {
          showBundleStockWarning(bundleGroupEl, errorMessage);
        }
        // 恢复输入框的值为当前数量
        const input = bundleGroupEl ? bundleGroupEl.querySelector('.static-cart__quantity-input') : null;
        if (input) {
          input.value = currentQuantity;
        }
        return;
      }

      // 更新整体购物车显示
      updateCartDisplay(updatedCart);

      // 如果购物车为空，刷新页面显示空购物车
      if (updatedCart.item_count === 0) {
        window.location.reload();
        return;
      }

      // 使用 Section Rendering API 更新购物车内容
      await refreshCartSection();

      // 减少数量成功，隐藏警告并启用按钮
      if (!isIncreasing) {
        const newBundleGroupEl = document.querySelector(`.static-cart__bundle-group[data-bundle-id="${bundleId}"]`);
        if (newBundleGroupEl) {
          hideBundleStockWarning(newBundleGroupEl);
        }
      }

    } catch (error) {
      console.error('更新 Bundle 数量失败:', error);
    } finally {
      // 移除 spinner
      if (spinner) {
        spinner.remove();
      }
      if (bundleGroupEl) bundleGroupEl.dataset.updating = 'false';
    }
  }
  
  // 处理 Bundle 数量变化 - 旧版 (通过 keys 列表)
  // delta：+/- 按钮点击时传进来的增量（+1/-1）；不传时 newQuantity 就是要设置的绝对值
  async function handleBundleQuantityChange(keys, newQuantity, bundleEl, delta) {
    if (!keys || keys.length === 0) return;

    // 如果正在处理中，直接返回
    if (bundleEl.dataset.updating === 'true') return;
    bundleEl.dataset.updating = 'true';

    // 显示 loading 指示器
    const quantityWrapper = bundleEl.querySelector('.static-cart__bundle-quantity .static-cart__quantity');
    let spinner = null;
    if (quantityWrapper) {
      spinner = document.createElement('span');
      spinner.className = 'cart-spinner';
      spinner.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6D4C41" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-opacity="0.2"/><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.6s" repeatCount="indefinite"/></path></svg>';
      quantityWrapper.style.position = 'relative';
      quantityWrapper.appendChild(spinner);
    }

    try {
      // 这一组 key 一起走 runMulti：原因见 handleBundleQuantityChangeById 同类改动的注释
      await window.SicotasCartLineLock.runMulti(keys, async () => {
        let targetQuantity = newQuantity;
        if (typeof delta === 'number') {
          // +/- 点击：拿到锁之后现读一次最新数量做基准再加/减，不信任点击那一刻的 DOM 值
          const freshCart = await getCart();
          const freshItem = freshCart.items.find(item => keys.includes(item.key));
          const baseQuantity = freshItem ? freshItem.quantity : 0;
          targetQuantity = Math.max(0, Math.min(30, baseQuantity + delta));
        }

        // 构建更新对象
        const updates = {};
        keys.forEach(key => {
          updates[key] = targetQuantity;
        });

        const response = await fetch(`${CONFIG.routes.cartUpdate}?t=${Date.now()}`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        const cart = await response.json();

        // 更新整体购物车显示
        updateCartDisplay(cart);

        // 如果购物车为空，刷新页面显示空购物车
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        // 使用 Section Rendering API 更新购物车内容
        await refreshCartSection();
      });

    } catch (error) {
      console.error('更新 Bundle 数量失败:', error);
    } finally {
      // 移除 spinner
      if (spinner) {
        spinner.remove();
      }
      bundleEl.dataset.updating = 'false';
    }
  }

  // 添加 spinner 样式
  function addStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .cart-spinner {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 4px;
        z-index: 5;
      }
      .cart-migration-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.9);
        z-index: 99999;
      }
      .cart-migration-overlay svg {
        width: 48px;
        height: 48px;
      }
    `;
    document.head.appendChild(style);
  }

  // 渲染折扣标签（从Cart API数据）
  function renderDiscountTags(cart) {
    cart.items.forEach(item => {
      if (item.discounts && item.discounts.length > 0) {
        // 用 item.key（variant_id:properties哈希，逐行唯一）查找 row，不能用 variant_id——
        // 拆分迁移后，两条来源不同（各自带着不同优惠券 properties）的旧行完全可能收敛到
        // 同一个新 variant，此时 variant_id 在购物车里不是唯一的，用它做 querySelector
        // 只会一直命中第一条匹配的 DOM 行，导致后处理的那一行把先处理的那一行数据覆盖掉，
        // 显示金额对不上（实测这就是"两条同 variant_id 的行显示同一个错误金额"的根因）
        const row = document.querySelector(`.static-cart__row[data-key="${item.key}"]`);
        if (!row) return;
        
        const desktopContainers = row.querySelectorAll('.static-cart__discount-tags-container');
        const mobileContainers = row.querySelectorAll('.static-cart__discount-tags-mobile');
        
        // 计算折扣金额
        const totalDiscountAmount = item.discounts.reduce((sum, d) => sum + d.amount, 0);
        
        // 计算折扣百分比
        let discountPercent = 0;
        if (item.original_line_price > 0) {
          discountPercent = Math.round((totalDiscountAmount / item.original_line_price) * 100);
        }
        
        // 处理桌面端容器
        desktopContainers.forEach(container => {
          // 清空现有的折扣标签
          container.innerHTML = '';
          
          // 添加折扣标签
          item.discounts.forEach(discount => {
            const tag = document.createElement('span');
            tag.className = 'static-cart__discount-tag static-cart__discount-tag--desktop';
            
            // 截断过长的文本
            const displayTitle = discount.title.length > 15 
              ? discount.title.substring(0, 15) + '...' 
              : discount.title;
            
            // 添加完整标题用于hover显示
            tag.title = discount.title;
            
            tag.innerHTML = `
              <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 12 12" style="width: 10px; height: 10px; margin-right: 4px;">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
              </svg>
              ${displayTitle}
            `;
            container.appendChild(tag);
          });
        });
        
        // 渲染折扣金额文本
        const amountContainers = row.querySelectorAll('.static-cart__discount-amount-text');
        amountContainers.forEach(container => {
          if (totalDiscountAmount > 0) {
            container.dataset.itemKey = item.key;
            container.textContent = `(-${discountPercent}% Save $${(totalDiscountAmount / 100).toFixed(2)})`;
            container.style.display = ''; // 确保显示
          } else {
            container.textContent = '';
            container.style.display = 'none'; // 无折扣时隐藏
          }
        });
        
        // 渲染最终支付金额（零售价 - 折扣总额）
        // 使用 Math.round 确保结果是整数 cents，避免浮点数精度问题
        const actualFinalPrice = Math.round(item.original_line_price - totalDiscountAmount);
        
        // PC端最终价格
        const finalPriceEl = row.querySelector('.static-cart__price-final');
        if (finalPriceEl) {
          finalPriceEl.textContent = formatMoney(actualFinalPrice);
          finalPriceEl.style.display = '';
        }
        
        // 移动端最终价格
        const finalPriceMobileEl = row.querySelector('.static-cart__price-final-mobile');
        if (finalPriceMobileEl) {
          finalPriceMobileEl.textContent = formatMoney(actualFinalPrice);
          finalPriceMobileEl.style.display = '';
        }
        
        // 处理移动端容器
        mobileContainers.forEach(container => {
          container.innerHTML = '';
          item.discounts.forEach(discount => {
            const tag = document.createElement('span');
            tag.className = 'static-cart__discount-tag static-cart__discount-tag--mobile';
            
            tag.innerHTML = `
              <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 12 12" style="width: 10px; height: 10px; margin-right: 4px;">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
              </svg>
              ${discount.title}
            `;
            container.appendChild(tag);
          });
        });
      }
    });
  }

  // 初始化时更新购物车数量（首次加载页面）
  async function initCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // 计算正确的商品数量：bundle作为一个商品统计
      let displayedItemCount = 0;
      const countedBundleIds = new Set();
      
      cart.items.forEach(item => {
        const isBundleItem = item.properties && item.properties._bundle === 'true';
        const bundleId = item.properties && item.properties._bundle_id;
        
        if (isBundleItem && bundleId) {
          if (!countedBundleIds.has(bundleId)) {
            countedBundleIds.add(bundleId);
            displayedItemCount += item.quantity;
          }
        } else {
          displayedItemCount += item.quantity;
        }
      });
      
      // 更新顶部导航购物车数量
      updateHeaderCartCount(displayedItemCount);
      
      // 更新 Subtotal 标题
      const subtotalTitle = document.querySelector(CONFIG.selectors.subtotalTitle);
      if (subtotalTitle) {
        subtotalTitle.textContent = `Subtotal ( ${displayedItemCount} Items )`;
      }
      
      // 渲染折扣标签
      renderDiscountTags(cart);
    } catch (error) {
      console.error('初始化购物车数量失败:', error);
    }
  }

  // 检测并静默迁移购物车里因商品拆分而失效的 variant；找不到映射的保留原样并标记异常
  function showCartMigrationOverlay() {
    if (document.querySelector('.cart-migration-overlay')) return;

    const overlay = document.createElement('div');
    overlay.className = 'cart-migration-overlay';
    overlay.innerHTML = '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6D4C41" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-opacity="0.2"/><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.6s" repeatCount="indefinite"/></path></svg>';
    document.body.appendChild(overlay);
  }

  function hideCartMigrationOverlay() {
    const overlay = document.querySelector('.cart-migration-overlay');
    if (overlay) overlay.remove();
  }

  // 等新渲染出的商品行图片全部加载完（或超时兜底）再放行，避免图片异步加载撑开/
  // 收缩行高导致的版面变化发生在遮罩已经消失之后，把下方 Checkout 按钮顶到用户刚点的位置
  function waitForImagesToLoad(container, timeoutMs) {
    if (!container) return Promise.resolve();
    const imgs = Array.from(container.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();
    return Promise.all(imgs.map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise(resolve => {
        const done = () => resolve();
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        setTimeout(done, timeoutMs);
      });
    }));
  }

  // 等浏览器真正完成一次布局与绘制，确保刚写入的 DOM 变更已经反映到屏幕上，
  // 而不是还停留在“已提交但未绘制”的状态
  function waitForLayoutSettled() {
    return new Promise(resolve => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });
  }

  async function migrateStaleCartVariants() {
    if (!window.VariantMigration || !document.querySelector(CONFIG.selectors.cartContainer)) return;

    let cart;
    try {
      cart = await getCart();
    } catch (error) {
      return;
    }

    // 遮罩必须盖住从"检测到失效商品"到"新商品+优惠券完全替换完毕、页面重新渲染完成"
    // 的整个过程，中途不能有任何空档，否则用户可能在中间态（旧行已删/新行未渲染，或
    // 金额未刷新）点到 checkout 或其他操作。安全兜底定时器只用来防止极端情况下
    // （网络卡死等）遮罩永久卡死，正常流程里 finally 会先一步清掉它、不会提前误触发
    let safetyTimer = null;
    try {
      const result = await window.VariantMigration.migrateCart(cart, {
        // 检测阶段一确认真的有失效商品就立刻显示遮罩，尽量在实际迁移开始前
        // 给用户留出操作窗口，避免正常购物车也跟着闪一下
        onStaleDetected: () => {
          showCartMigrationOverlay();
          safetyTimer = setTimeout(hideCartMigrationOverlay, 30000);
        }
      });

      if (result.migratedCount > 0) {
        await refreshCartSection();
        try {
          // refreshCartSection 只替换商品行列表（#new-cart-items），Order summary 的
          // Total/划线价合计/Discount/You Save 这些汇总金额、以及顶部购物车数量都是
          // updateCartDisplay 统一算的，不调用就还停留在迁移前的旧值。
          // migrateCart 迁移干净时内部已经现读过一次最终购物车（用于签名缓存），通过
          // result.cart 直接复用，省掉一次可能失败的重复请求；拿不到（比如有 anomalies
          // 没读那一步）才退回自己读，并用指数退避多试几次，而不是只重试一次固定延迟
          const freshCart = result.cart || await getCartWithRetry();
          updateCartDisplay(freshCart);
        } catch (error) {
          console.error('[variant-migration] failed to refresh cart display:', error);
        }
        // 新行的图片加载完、浏览器完成一次真实绘制之后，画面才算真正稳定，
        // 此时才是遮罩可以放行的最早时机
        await waitForImagesToLoad(document.querySelector('#new-cart-items'), 3000);
        await waitForLayoutSettled();
      }

      result.anomalies.forEach(item => {
        // 同样改用 item.key，理由见 renderDiscountTags 里的注释——variant_id 在购物车里
        // 不保证唯一，用它查找容易命中错误的行
        const row = document.querySelector(`.static-cart__row[data-key="${item.key}"]`);
        showMigrationAnomalyBadge(row, 'This item has been updated. Please remove and reselect it.');
      });
    } finally {
      if (safetyTimer) clearTimeout(safetyTimer);
      hideCartMigrationOverlay();
    }
  }

  // 初始化
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        addStyles();
        bindEvents();
        initCartCount();
        setupCartUpdateListener();
        migrateStaleCartVariants();
      });
    } else {
      addStyles();
      bindEvents();
      initCartCount();
      setupCartUpdateListener();
      migrateStaleCartVariants();
    }
  }
  
  // 监听购物车更新事件（从心愿单添加商品时触发）
  function setupCartUpdateListener() {
    document.addEventListener('cart:updated', async (e) => {
      console.log('🔄 Cart updated from:', e.detail?.source || 'unknown');

      // 刷新购物车section显示
      await refreshCartSection();

      // 更新购物车数量和折扣标签
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        updateHeaderCartCount(cart.item_count);

        // 重新渲染折扣标签
        renderDiscountTags(cart);

        // 更新心愿单section（如果存在）
        if (window.CartWishlist && window.CartWishlist.init) {
          setTimeout(() => {
            window.CartWishlist.init();
          }, 500);
        }
      } catch (error) {
        console.error('Failed to update cart count:', error);
      }
    });
  }

  init();
})();
